import { apiRequest } from "./apiClient";

export async function sendInvoiceToFBR({ userId, invoice }) {
  if (!userId || !invoice) {
    throw new Error("Missing required parameters: userId or invoice");
  }

  try {
    const data = await apiRequest("/api/fbr/fbr-invoice", {
      method: "POST",
      body: JSON.stringify({ userId, invoice }),
    });

    return data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("FBR API Error:", error.message);
    throw error;
  }
}

export async function sendPRAInvoiceToFBR({ userId, invoice }) {
  if (!userId || !invoice) {
    throw new Error("Missing required parameters: userId or invoice");
  }

  try {
    const data = await apiRequest("/api/fbr/fbr-pra-invoice", {
      method: "POST",
      body: JSON.stringify({ userId, invoice }),
    });

    return data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("FBR API Error:", error.message);
    throw error;
  }
}

export async function sendDigitalInvoiceToFBR({ userId, invoice }) {
  if (!userId || !invoice) {
    throw new Error("Missing required parameters: userId or invoice");
  }

  console.log("digital invoice from utils:", invoice);

  try {
    const data = await apiRequest("/api/fbr/fbr-digital-invoice", {
      method: "POST",
      body: JSON.stringify({ userId, invoice }),
    });

    return data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("FBR API Error:", error.message);
    throw error;
  }
}